import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'
import adminOnboardingGetIsTrialFromSFSelector from 'redux/selectors/admin_onboarding/admin_onboarding_is_trial_from_sf_selector'

const getAdminOnboardingData = state => state.adminOnboarding
const getUser = state => state.user

const inviteAdminOnboarding = createSelector(
	[getAdminOnboardingData, getUser, adminOnboardingGetIsTrialFromSFSelector],
	(adminOnboarding, user, isTrialFromSFData) => {
		let showSendButton = false
		let showButtonTooltip = false
		let showUserTooltip = false
		let users = []
		let usersSelected = []
		let usersSelectedIds = []
		let usersSuggested = 0
		let usersCreated = 0
		let userInviteText = localize('admin_onboarding_express_select_colleagues')
		let schoolName = ''
		if (user.data) {
			if (user.data.hasOwnProperty('account')) {
				schoolName = user.data.account.schoolName
			}
			if (adminOnboarding.users.length > 0) {
				usersSelected = adminOnboarding.users.filter(function(element) {
					return element.selected
				})
				usersSelectedIds = usersSelected.map(element => {
					if (element.belongsToInstitution || !element.isNew) {
						usersSuggested++
					} else {
						usersCreated++
					}
					return element.id
				})
				users = adminOnboarding.users.map(element => {
					const fullName = element.firstName + ' ' + element.lastName
					let userIsMe = false
					if (element.id === user.data.userId) {
						userIsMe = true
					}
					let isInSchool = false
					if (element.schoolId > 0) {
						isInSchool = true
					}
					const newElement = { ...element, fullName, userIsMe, isInSchool }
					return newElement
				})
				if (usersSelected.length > 0) {
					userInviteText = usersSelected.length +' '+localize('admin_onboarding_express_select_colleagues_plural')
					if (usersSelected.length === 1) {
						userInviteText = '1 ' + localize('admin_onboarding_express_select_colleagues_singular')
					}
					showSendButton = true
					showButtonTooltip = true
				} else if (usersSelected.length === 0) {
					showUserTooltip = true
				}
			}
		}

		return {
			showQuestionsTooltip: true,
			userInviteText,
			users,
			usersSelected: usersSelected.length,
			currentUsers: users.length - 1,
			usersSelectedIds,
			usersSuggested,
			usersCreated,
			showSendButton,
			showButtonTooltip,
			showUserTooltip,
			redirectAfterInvite: adminOnboarding.redirectAfterInvite,
			schoolName,
			/*welcomeInviteTeacher: adminOnboarding.welcomeInviteTeacher,*/
			inviteTeacher: adminOnboarding.inviteTeacher,
			isAdmin: adminOnboarding.isAdmin,
			isTrialFromSF: isTrialFromSFData.isTrialFromSF,
		}
	}
)

export default inviteAdminOnboarding
